import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import {
	Appointment,
	AppointmentQueryParams,
	DataUpdateMainInfo,
	Expense,
} from "../types";

interface AppointmentState {
	appointmentList: Array<Appointment>;
	appointmentTotal: number;
	loading: boolean;
	appointmentDetail: Appointment | null;
}

const initialState: AppointmentState = {
	loading: false,
	appointmentList: [],
	appointmentTotal: 0,
	appointmentDetail: null,
};

export const appointmentSlice = createSlice({
	name: "appointment",
	initialState,
	reducers: {
		setListAppointment: (state, action) => {
			state.appointmentList = action.payload.data;
			state.appointmentTotal = action.payload.total;
		},
		setDetailAppointment: (state, action) => {
			state.appointmentDetail = action.payload;
		},
		setStatusBookingCar: (state, action) => {
			state.appointmentDetail = action.payload.data;
		},
		resetDetailAppointment: state => {
			state.appointmentDetail = null;
		},
		setLoadingAppointment: (state, action) => {
			state.loading = action.payload;
		},
	},
});

export const selectAppointmentList = (state: RootState) =>
	state.appointment.appointmentList;
export const selectAppointmentTotal = (state: RootState) =>
	state.appointment.appointmentTotal;
export const selectAppointmentDetail = (state: RootState) =>
	state.appointment.appointmentDetail;
export const selectLoading = (state: RootState) => state.appointment.loading;

export const {
	setListAppointment,
	setDetailAppointment,
	resetDetailAppointment,
	setLoadingAppointment,
	setStatusBookingCar,
} = appointmentSlice.actions;

export interface GetListAppointmentAsyncPayload {
	query: AppointmentQueryParams;
	callback?: () => void;
}
export const getListAppointmentAsync = createAction(
	"appointment/getListAppointmentAsync",
	(payload: GetListAppointmentAsyncPayload) => ({
		payload: payload,
	}),
);

// Detail
export interface GetDetailAppointmentAsyncPayload {
	id: string | number;
}
export const getDetailAppointmentAsync = createAction(
	"appointment/getDetailAppointmentAsync",
	(payload: GetDetailAppointmentAsyncPayload) => ({
		payload,
	}),
);

// Update
export interface UpdateAppointmentAsyncPayload {
	data: DataUpdateMainInfo;
	id: string;
	getResult: (arg: boolean) => void;
}
export const updateAppointmentAsync = createAction(
	"appointment/updateAppointmentAsync",
	(payload: UpdateAppointmentAsyncPayload) => ({
		payload,
	}),
);

// add a expense
export interface AddExpenseAsyncPayload {
	data: Expense;
	bookId: string | number;
	getResult: (arg: { success: boolean; id: number }) => void;
}
export const addExpenseAsync = createAction(
	"appointment/addExpenseAsync",
	(payload: AddExpenseAsyncPayload) => ({
		payload,
	}),
);

// update expense
export interface UpdateExpenseAsyncPayload {
	id: string | number;
	bookId: string | number;
	data: Expense;
	getResult: (arg: boolean) => void;
}
export const updateExpenseAsync = createAction(
	"appointment/updateExpenseAsync",
	(payload: UpdateExpenseAsyncPayload) => ({
		payload,
	}),
);

// delete expense
export interface DeleteExpenseAsyncPayload {
	bookId: string | number;
	id: string | number;
	getResult: (arg: boolean) => void;
}
export const deleteExpenseAsync = createAction(
	"appointment/deleteExpenseAsync",
	(payload: DeleteExpenseAsyncPayload) => ({
		payload,
	}),
);

//update status of bookingCar
export interface UpdateStatusBookingCarAsyncPayload {
	id: string | number;
	status: string;
	language: string;
}
export const UpdateStatusBookingCarAsync = createAction(
	"appointment/updateStatusBookingCarAsync",
	(payload: UpdateStatusBookingCarAsyncPayload) => ({
		payload,
	}),
);

// add a service
export interface AddServiceAsyncPayload {
	data: { services: number[] };
	bookId: string | number;
	getResult: (arg: { success: boolean }) => void;
}
export const addServiceAsync = createAction(
	"appointment/addServiceAsync",
	(payload: AddServiceAsyncPayload) => ({
		payload,
	}),
);

// delete a service
export interface DeleteServiceAsyncPayload {
	serviceId: string | number;
	bookId: string | number;
	getResult: (arg: { success: boolean }) => void;
}
export const deleteServiceAsync = createAction(
	"appointment/deleteServiceAsync",
	(payload: DeleteServiceAsyncPayload) => ({
		payload,
	}),
);

export default appointmentSlice.reducer;
